import { useLoading } from "@/composables/useLoading";
import apiClient from "@/services/axios";
import { RouteRecordRaw } from "vue-router";

const privateRoutes: Array<RouteRecordRaw> = [
    {
      path: "/admin",
      name: "admin",
      components: { private: () => import("@/views/private/Admin/AdminView.vue") },
      meta: { 
        titleKey: 'page_titles.admin', 
        requiresAuth: true, 
        requiresAdmin: true 
      },
    },
    {
      path: "/plans",
      alias: "/plans",
      name: "plans",
      components: { private: () => import("@/views/private/PlansView.vue") },
      meta: { titleKey: 'page_titles.plans', requiresAuth: true },
    },
    {
      path: "/profile",
      alias: "/profile",
      name: "profile",
      components: { private: () => import("@/views/private/ProfileView.vue") },
      meta: { titleKey: 'page_titles.profile', requiresAuth: true },
    },
    {
      path: "/edit-name",
      alias: "/edit-name",
      name: "edit-name",
      components: { private: () => import("@/views/private/EditNameView.vue") },
      meta: { titleKey: 'page_titles.edit_name', requiresAuth: true },
    },
    {
      path: "/edit-email",
      alias: "/edit-email",
      name: "edit-email",
      components: { private: () => import("@/views/private/EditEmailView.vue") },
      meta: { titleKey: 'page_titles.edit_email', requiresAuth: true },
    },
    {
      path: "/edit-password",
      alias: "/edit-password",
      name: "edit-password",
      components: { private: () => import("@/views/private/EditPasswordView.vue") },
      meta: { titleKey: 'page_titles.edit_password', requiresAuth: true },
    },
    {
      path: "/edit-language",
      alias: "/edit-language",
      name: "edit-language",
      components: { private: () => import("@/views/private/EditLanguageView.vue") },
      meta: { titleKey: 'page_titles.edit_language', requiresAuth: true },
    },
    {
      path: "/notifications",
      alias: "/notifications",
      name: "notifications",
      components: { private: () => import("@/views/private/NotificationsView.vue") },
      meta: { titleKey: 'page_titles.notifications', requiresAuth: true },
    },
    {
      path: "/help",
      alias: "/help",
      name: "help",
      components: { private: () => import("@/views/private/HelpView.vue") },
      meta: { titleKey: 'page_titles.help', requiresAuth: true },
    },
    {
      path: "/payments",
      alias: "/payments",
      name: "payments",
      components: { private: () => import("@/views/private/PaymentsView.vue") },
      meta: { titleKey: 'page_titles.payments', requiresAuth: true },
    },
    {
      path: "/settings",
      alias: "/settings",
      name: "settings",
      components: { private: () => import("@/views/private/SettingsView.vue") },
      meta: { titleKey: 'page_titles.settings', requiresAuth: true }
    },
    {
      path: "/home",
      alias: "/home",
      name: "home",
      components: { private: () => import("@/views/private/HomeView.vue") },
      meta: { titleKey: 'page_titles.home', requiresAuth: true },
    },
    {
      path: '/edit-device/:id/:name/:type',
      alias: '/edit-device/:id/:name/:type',
      name: 'edit-device',
      components: { private: () => import("@/views/private/EditDeviceView.vue") },
      meta: { titleKey: 'page_titles.edit_device', requiresAuth: true },
      beforeEnter: async (to, from, next) => {
      const { showLoading, hideLoading } = useLoading();
      showLoading();

      try {
        const { id } = to.params;

        const response = await apiClient.get(`/devices/${id}`);
        if (!response.data) return next({ name: 'not-authorized' });

        const setupKeyId = response.data.firstSetupKey?.split('/').pop();
        if (!setupKeyId) return next({ name: 'not-authorized' });

        const keyResponse = await apiClient.get(`/setup_keys/${setupKeyId}`);
        // console.log(keyResponse);
        to.meta.shortKey = keyResponse.data.shortCode;

        next();
      } catch (error) {
        console.error('Failed to get setup key:', error);
        next({ name: 'not-authorized' });
      } finally {
        hideLoading();
      }
    }
    },
    {
      path: '/not-authorized',
      name: 'not-authorized',
      components: { public: () => import("@/views/errors/NotAuthorizedView.vue") },
      meta: { titleKey: 'page_titles.not_authorized', requiresAuth: false },
    },
  
  ];

  export default privateRoutes;